import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class RegulatoryItemsConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	isRegulatoryItemsClockVisible$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.coreUi.regulatoryItems.isRegulatoryItemsClockVisible, true);
	}

	isRegulatoryItemsSessionTimerVisible$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.coreUi.regulatoryItems.isRegulatoryItemsSessionTimerVisible, true);
	}
}
